import { Map } from 'immutable';
import actions from '../../constants/portal/prozorro';

const defaultState = () => new Map({
  tenderList: undefined,
  isLoading: false
})

export default (state = defaultState(), action) => {
  switch (action.type) {
    case actions.LOAD_TENDERS:
      return state.set('tenderList', action.data);
    case actions.TENDERS_ARE_LOADING:
      return state.set('isLoading', action.data);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/portal/prozorro.js